import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { ConfirmDialog } from "./confirm-dialog";

/**
 * Promise-based confirm dialog. Mount ConfirmDialogHost once (via ConfirmProvider).
 */
export function useConfirmDialog() {
  const { t } = useTranslation();
  const [state, setState] = useState(null);

  const confirm = useCallback((options) => {
    return new Promise((resolve) => {
      setState({ ...options, resolve });
    });
  }, []);

  const close = useCallback((result) => {
    setState((prev) => {
      prev?.resolve?.(result);
      return null;
    });
  }, []);

  const confirmDelete = useCallback(
    (options = {}) =>
      confirm({
        variant: "danger",
        title: options.title ?? t("common.confirm.deleteTitle", "Emin misiniz?"),
        message: options.message ?? t("common.confirm.deleteMessage", "Bu işlem geri alınamaz."),
        confirmLabel: options.confirmLabel ?? t("common.confirm.yesDelete", "Evet, sil"),
        cancelLabel: options.cancelLabel,
        ...options,
      }),
    [confirm, t]
  );

  const ConfirmDialogHost = useCallback(
    () => (
      <ConfirmDialog
        open={!!state}
        title={state?.title ?? ""}
        message={state?.message}
        variant={state?.variant ?? "default"}
        confirmLabel={state?.confirmLabel}
        cancelLabel={state?.cancelLabel}
        loading={state?.loading}
        onConfirm={() => close(true)}
        onCancel={() => close(false)}
      />
    ),
    [state, close]
  );

  return { confirm, confirmDelete, ConfirmDialogHost };
}
